/**
 * The Root Layout object.
 * Holding the other regions of the application.
 * @version 1.2.0
 */
import View from 'scripts/poppet/view';

const selectors = {
	app      : '[data-application=defa]',
	main     : '[data-region=defa-main]',
	support  : '[data-region=technical-support]',
};
	
const Root = View.extend({
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
		
	el           : selectors.app,
	className    : '',
	mainRegion   : 'main',
		
	regions: {
		main     : selectors.main,
		support  : selectors.support,
	},
		
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
		
	// ------------------------------------------------
	// Other Functions
	// ------------------------------------------------
		
});
	
export default Root;